import requestApis from "apis/request";
import { commonConstants } from "constants/index";
import {
  CancelDeliveryPayload,
  CreateDeliveryResponse,
  DeliveryPayload,
  IProviderWithServices,
  IShipment,
  LogisticsDeliveryRequestGetListPayload,
  LogisticsDeliveryRequestGetListResponse,
  LogisticsTransportGetListPayload,
  LogisticsTransportGetListResponse,
} from "models";

const { staffBffClient, staffBffNoErrorNotiClient } = requestApis;
const { X_SELLER_ID } = commonConstants;

const cancelDeliveryRequest = async (payload: CancelDeliveryPayload): Promise<any> => {
  try {
    const { deliveryRequestId } = payload;
    const res = await staffBffClient.post(`/api/v1/delivery/${deliveryRequestId}/cancel-request`, {
      params: {
        deliveryRequestId,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

const createDeliveryRequest = async (
  payload: DeliveryPayload,
  sellerId: IShipment["sellerId"]
): Promise<CreateDeliveryResponse> => {
  const ret = await staffBffClient.post("/api/v1/delivery/request", payload, {
    headers: { [X_SELLER_ID]: sellerId },
  });
  return ret.data.data;
};

const getProviderServices = async (sellerId: IShipment["sellerId"]): Promise<IProviderWithServices[]> => {
  const response = await staffBffClient.get("/api/v1/delivery/provider-services", {
    headers: { [X_SELLER_ID]: sellerId },
  });
  return response.data.providers || [];
};

// The logistics planner lists below are an optional enrichment, so they do not notify on error

const getLogisticsDeliveryRequests = async (
  payload: LogisticsDeliveryRequestGetListPayload
): Promise<LogisticsDeliveryRequestGetListResponse> => {
  const res = await staffBffNoErrorNotiClient.post("/api/v1/delivery-requests", payload);
  return res.data.data || {};
};

const getLogisticsTransports = async (
  payload: LogisticsTransportGetListPayload
): Promise<LogisticsTransportGetListResponse> => {
  const res = await staffBffNoErrorNotiClient.post("/api/v1/transports", payload);
  return res.data.data || {};
};

export default {
  cancelDeliveryRequest,
  createDeliveryRequest,
  getProviderServices,
  getLogisticsDeliveryRequests,
  getLogisticsTransports,
};
